import React, { createContext, useContext, useState } from 'react';

const ShowListEditOptionContext = createContext();

export const ShowListEditOptionProvider = ({ children }) => {
  const [showListEditOption, setShowListEditOption] = useState(false);

  return (
    <ShowListEditOptionContext.Provider
      value={{ showListEditOption, setShowListEditOption }}
    >
      {children}
    </ShowListEditOptionContext.Provider>
  );
};

export const useShowListEditOptionContext = () =>
  useContext(ShowListEditOptionContext);
